<template>
  <div class="social-signin" id="google" @click="onClick">
    <img class= "social-logo"  src="/static/images/signin/google/btn_google_dark_normal_ios.svg"> <!--id="google"-->
    <div class="social-text" id="google"><slot>Sign in with Google</slot></div><!--id="google"-->

  </div>
</template>

<style>
@import "~scss/social.scss";

</style>

<script>
export default {
  data() {
    return {gapiReady: null, gauth: null};
  },
  mounted() {
    this.gapiReady = new Promise(resolve => {
      window.initGoogle = () => {
        gapi.load('auth2', () => {
          gapi.auth2.init(this.authConfig);
          this.gauth = gapi.auth2.getAuthInstance();
          resolve();
        });
      };
    });
    this.addScript('https://apis.google.com/js/api:client.js?onload=initGoogle');
  },
  computed: {
    authConfig() {
      return {client_id: "255072882725-39ksd3fajhgu2nea796vp8nm6qb4ket2.apps.googleusercontent.com"};
    }
  },
  methods: {
    async onClick() {
      console.log('onClick!');
      await this.gapiReady;
      console.log('onClick 2');
      var info = await this.gauth.signIn();
      console.log('gauth', info);
      this.$emit('login', this.extractUserInfo(info));
    },
    extractUserInfo(guser) {
      var profile = guser.getBasicProfile();
      return {
        auth: guser.getAuthResponse(true),
        id: profile.getId(),
        name: profile.getName(),
        givenName: profile.getGivenName(),
        familyName: profile.getFamilyName(),
        imageUrl: profile.getImageUrl(),
        email: profile.getEmail(),
      };
    },
    addScript(src) {
      let node = document.createElement('script');
      node.setAttribute('src', src);
      node.setAttribute('async', '');
      document.head.appendChild(node);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/GoogleSignIn.vue